import React from 'react';
import { SupplierDetailDrawerView } from './SupplierDetailDrawerView';
import { useSupplierDetailDrawer } from './useSupplierDetailDrawer';
import type { Supplier } from '../suppliersMeta';

type SupplierDetailDrawerProps = {
    /** True when the signed-in user may withdraw a payment (OrgAdmin only). */
    canDeletePayments: boolean;
    onClose: () => void;
    onRecordPayment: () => void;
    /** The supplier to show; `null` closes the drawer. */
    supplier: Supplier | null;
};

/**
 * Container for the supplier account drawer: owns the data hook and hands its
 * output to the render-only View.
 */
export const SupplierDetailDrawer: React.FC<SupplierDetailDrawerProps> = ({
    canDeletePayments,
    onClose,
    onRecordPayment,
    supplier,
}) => {
    const drawer = useSupplierDetailDrawer({
        supplierId: supplier?.id ?? null,
    });

    return (
        <SupplierDetailDrawerView
            canDeletePayments={canDeletePayments}
            drawer={drawer}
            onClose={onClose}
            onRecordPayment={onRecordPayment}
            supplier={supplier}
        />
    );
};
